import siteConfig from '../../config/site-config.js';

function resolveAdminRequestUrl(apiBaseUrl, url) {
  if (!url) return apiBaseUrl;
  if (/^https?:\/\//i.test(url)) return url;
  const origin = String(apiBaseUrl || '').replace(/\/api\/?$/i, '');
  if (url.startsWith('/api/')) return `${origin}${url}`;
  if (url.startsWith('/')) return `${origin}${url}`;
  const base = String(apiBaseUrl || '').replace(/\/?$/, '');
  return `${base}/${url}`;
}

/** 创建管理后台请求函数。仅 401 视为登录失效；403 表示无权限，不强制退出。 */
export function createAdminApiRequest(token, onUnauthorized) {
  const apiBaseUrl = siteConfig.getApiUrl();
  return async (url, options = {}) => {
    const isFormData = typeof FormData !== 'undefined' && options.body instanceof FormData;
    const headers = { ...(options.headers || {}) };
    // FormData 必须由浏览器自动带 multipart boundary，不能强制 application/json
    if (!isFormData && !headers['Content-Type']) {
      headers['Content-Type'] = 'application/json';
    }
    if (isFormData && headers['Content-Type']) {
      delete headers['Content-Type'];
    }
    if (token) headers.Authorization = `Bearer ${token}`;
    try {
      const fullUrl = resolveAdminRequestUrl(apiBaseUrl, url);
      console.log(`API请求URL: ${fullUrl}`);
      const response = await fetch(fullUrl, { ...options, headers });
      if (response.status === 401) {
        onUnauthorized();
        return { success: false, error: '登录已过期，请重新登录', status: 401 };
      }
      let data = {};
      try {
        data = await response.json();
      } catch (_) {
        data = {};
      }
      if (response.status === 403) {
        return { success: false, error: data.error || '无权执行此操作', status: 403 };
      }
      if (response.status === 404) {
        return {
          success: false,
          error: data.error || '接口不存在(404)。若刚加了上传功能，请重启本地后端后再试',
          status: 404
        };
      }
      if (!response.ok) {
        return {
          success: false,
          error: data.error || `请求失败(${response.status})`,
          status: response.status,
          detail: data.detail
        };
      }
      console.log(`API调用成功: ${url}`, data);
      return data;
    } catch (error) {
      console.error(`API调用失败: ${url}`, error);
      return { success: false, error: '网络错误' };
    }
  };
}
